import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../shared/components/VerbButton';
import { removeHTMLtagsAndDoubleQuotes } from '../../../../shared/utils/StringUtils';

class DimensionsRow extends PureComponent {
    render() {
        const { dimension = {}, history } = this.props;

        const { _id, name, createdOn } = dimension;
        return (
            <tr key={_id}>
                <td className={'buttonCell'}>
                    <VerbButton
                        buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                        className={'dimension-action-button'}
                        fontAwesomeIcon={'fa-pencil'}
                        onClick={() => history.push(`/editdimension/${_id}`)}
                    />
                </td>
                <td>{removeHTMLtagsAndDoubleQuotes(name)}</td>
                <td>{moment(createdOn).format('MMM Do YYYY')}</td>
            </tr>
        );
    }
}

DimensionsRow.propTypes = {
    dimension: PropTypes.shape({
        _id: PropTypes.string,
        name: PropTypes.string,
        createdOn: PropTypes.string
    }),
    history: PropTypes.object
};

export default DimensionsRow;
